import React, { useState } from 'react';
import { galleryImages, storeInfo } from '../data/mockData';
import { Instagram, X } from 'lucide-react';

const GallerySection = () => {
  const [lightbox, setLightbox] = useState(null);

  return (
    <section id="gallery" className="py-20 bg-[#0a0a0a]">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-4xl md:text-5xl font-bold text-center mb-4">
          <span className="text-[#c8ff00]">Gallery</span>
        </h2>
        <p className="text-gray-400 text-center mb-4">
          Browse our collection of products, store displays, and lifestyle shots.
        </p>
        <div className="flex justify-center mb-10">
          <a
            href={storeInfo.contact.instagram}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-[#c8ff00] hover:text-[#b8ef00] transition-colors text-sm font-medium"
          >
            <Instagram size={16} />
            Follow us on Instagram
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {galleryImages.map((image, index) => (
            <div
              key={index}
              className="relative overflow-hidden rounded-xl cursor-pointer group aspect-square"
              onClick={() => setLightbox(index)}
            >
              <img
                src={image.src}
                alt={image.alt}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-colors duration-300" />
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {lightbox !== null && (
        <div
          className="fixed inset-0 z-[90] flex items-center justify-center bg-black/90 backdrop-blur-sm p-4"
          onClick={() => setLightbox(null)}
        >
          <button
            className="absolute top-6 right-6 text-white hover:text-[#c8ff00] transition-colors"
            onClick={() => setLightbox(null)}
            aria-label="Close"
          >
            <X size={32} />
          </button>
          <img
            src={galleryImages[lightbox].src.replace('w=500&h=500', 'w=1200&h=900')}
            alt={galleryImages[lightbox].alt}
            className="max-w-full max-h-[85vh] object-contain rounded-xl"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </section>
  );
};

export default GallerySection;
